<template>
  <v-dialog v-model="modalModelo" max-width="900px" class="impresso-modal" @click:outside="fecharModal">
    <div class="impresso-modal-container">
      <div class="modal-header">
        <div class="header-content">
          <div class="header-left">
            <div class="header-icon">
              <v-icon class="header-icon-white">mdi-file-document</v-icon>
            </div>
            <div class="header-text">
              <h2 class="header-title">Modelo Impresso Personalizado</h2>
              <p class="header-subtitle">Selecione o modelo para gerar o impresso</p>
            </div>
          </div>
        </div>
      </div>
      <div class="unified-content">
        <v-card class="unified-card">
          <div class="form-content">
            <div class="selection-section">
              <h3 class="section-title">Selecionar Modelo para impresso:</h3>
              <v-row>
                <v-col cols="12" md="6" sm="12">
                  <soi-select
                    :name="'Tipo'"
                    :label="'Modelos'"
                    :items="modelosImpressoPersonalizados"
                    item-text="nomeModelo"
                    item-value="id"
                    v-model="idModeloSelecionado"
                    class="modern-select">
                  </soi-select>
                </v-col>
              </v-row>
            </div>
          </div>
          <div class="form-actions">
            <div class="actions-container">
              <v-btn class="action-btn cancel-btn" :class="'warning'" @click="fecharModal()" :loading="carregando">
                <v-icon left>mdi-cancel</v-icon>
                Cancelar
              </v-btn>
              <v-btn class="action-btn save-btn" @click="salvar()" :loading="carregando" :disabled="desabilitadoBotaoSalvar">
                <v-icon left>mdi-content-save-check</v-icon>
                Salvar
              </v-btn>
            </div>
          </div>
        </v-card>
      </div>
    </div>
  </v-dialog>
</template>

<script lang="ts">
import Vue from 'vue';
import MaskHelper from '@/helpers/MaskHelper';
import { AlertaPerguntaSimOuNaoBooleano, MensagemMixin } from '@/helpers/MensagemHelper';
import { ImpressosPersonalizadosService } from '@/services/ImpressosPersonalizadosService';

export default Vue.extend({
  name: 'soi-modal-modelos-impresso-personalizado',
  data() {
    return {
      modalModelo: false,
      carregando: false,
      responseOk: false,
      masks: MaskHelper,
      modelosImpressoPersonalizados: [],
      idModeloSelecionado: 0,
      impressoPersonalizadoService: new ImpressosPersonalizadosService(),
      resolverPromessa: null as ((value: boolean) => void) | null,
    };
  },
  props: {
    fluxoParaAcionarModalModelo: {
      type: String,
      default: '',
      required: false,
    },
  },
  async mounted() {
    try {
      const resposta = await this.impressoPersonalizadoService.obterImpressosPersonalizadoSemPaginacao();
      this.modelosImpressoPersonalizados = resposta.data;
    } catch (error) {
      console.error('Erro ao carregar impressos personalizados:', error);
    }
  },
  computed: {
    desabilitadoBotaoSalvar() {
      return this.idModeloSelecionado === 0;
    },
  },
  watch: {
    modalModelo(newValue) {
      // Se o modal foi fechado sem passar pelo método fecharModal (ex: ESC ou clique fora)
      if (!newValue && this.resolverPromessa) {
        this.resolverPromessa(false);
        this.resolverPromessa = null;
      }
    },
  },
  methods: {
    async fecharModal() {
      // Resolve a Promise se existir, indicando que o modal foi cancelado
      if (this.resolverPromessa) {
        this.resolverPromessa(false);
        this.resolverPromessa = null;
      }

      if (this.fluxoParaAcionarModalModelo === 'Atendimento') {
        if (await AlertaPerguntaSimOuNaoBooleano('É obrigatório selecionar o modelo para prosseguir com a impressão. Caso clique em sim o impresso não será gerado!', 'Deseja realmente cancelar?')) {
          MensagemMixin(3000, 'success', 'Atendimento finalizado com sucesso.');
          this.modalModelo = false;
          this.$emit('atualizarAgenda');
          this.$router.push({
            name: 'atendimentos',
            params: { liberar: true },
          });
        } else {
          // Se o usuário cancelar, apenas fecha o modal
          this.modalModelo = false;
          this.$emit('atualizarAgenda');
        }
      } else if (this.fluxoParaAcionarModalModelo === 'RevisaoCompleta') {
        if (await AlertaPerguntaSimOuNaoBooleano('É obrigatório selecionar o modelo para prosseguir com a impressão. Caso clique em sim o impresso não será gerado!', 'Deseja realmente cancelar?')) {
          this.modalModelo = false;
          this.$emit('atualizarAgenda');
          this.$router.push({
            name: 'revisoes',
            params: { liberar: true },
          });
        } else {
          // Se o usuário cancelar, apenas fecha o modal
          this.modalModelo = false;
          this.$emit('atualizarAgenda');
        }
      } else if (this.fluxoParaAcionarModalModelo === 'Revisao') {
        if (await AlertaPerguntaSimOuNaoBooleano('É obrigatório selecionar o modelo para prosseguir com a impressão. Caso clique em sim o impresso não será gerado!', 'Deseja realmente cancelar?')) {
          this.modalModelo = false;
          this.$emit('atualizarAgenda');
          this.$router.push({
            name: 'revisoes',
            params: { liberar: true },
          });
        } else {
          // Se o usuário cancelar, apenas fecha o modal
          this.modalModelo = false;
          this.$emit('atualizarAgenda');
        }
      } else if (this.fluxoParaAcionarModalModelo === 'RelatorioPaciente') {
        if (await AlertaPerguntaSimOuNaoBooleano('É obrigatório selecionar o modelo para prosseguir com a impressão. Caso clique em sim o impresso não será gerado!', 'Deseja realmente cancelar?')) {
          this.modalModelo = false;
          this.$emit('atualizarAgenda');
          this.$router.go(0);
        } else {
          // Se o usuário cancelar, apenas fecha o modal
          this.modalModelo = false;
          this.$emit('atualizarAgenda');
        }
      } else if (this.fluxoParaAcionarModalModelo === 'GuiaMedicamento') {
        if (await AlertaPerguntaSimOuNaoBooleano('É obrigatório selecionar o modelo para prosseguir com a impressão. Caso clique em sim o impresso não será gerado!', 'Deseja realmente cancelar?')) {
          this.modalModelo = false;
          this.$emit('atualizarAgenda');
        } else {
          this.modalModelo = false;
          this.$emit('atualizarAgenda');
        }
      } else {
        this.modalModelo = false;
        this.$emit('atualizarAgenda');
      }
    },
    abrirModal() {
      this.modalModelo = true;
      return new Promise((resolve) => {
        this.resolverPromessa = resolve;
      });
    },
    async salvar() {
      if (this.resolverPromessa) {
        this.resolverPromessa(true);
        this.resolverPromessa = null;
      }
      this.modalModelo = false;
      this.$emit('salvarModelo', this.idModeloSelecionado);
    },
  },
});
</script>

<style scoped>
/* MODAL IMPRESSO PERSONALIZADO - ESTILO MODERNO */
.impresso-modal {
  z-index: 9999 !important;
}

.impresso-modal-container {
  background: white;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  max-width: 900px;
  margin: 0 auto;
}

/* HEADER MODERNO */
.modal-header {
  background: var(--especialidade-primary, #2e4b9d);
  padding: 24px 32px;
  position: relative;
}

.header-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 16px;
}

.header-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  border-radius: 12px;
}

.header-icon-white {
  color: white !important;
  font-size: 24px !important;
}

.header-text {
  flex: 1;
}

.header-title {
  color: white;
  font-size: 24px;
  font-weight: 600;
  margin: 0;
  line-height: 1.2;
}

.header-subtitle {
  color: rgba(255, 255, 255, 0.8);
  font-size: 14px;
  margin: 4px 0 0 0;
  font-weight: 400;
}

/* CONTEÚDO UNIFICADO */
.unified-content {
  padding: 0 24px 24px 24px;
}

.unified-card {
  border-radius: 16px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(0, 0, 0, 0.05);
}

.form-content {
  padding: 32px;
}

/* SEÇÃO DE SELEÇÃO */
.selection-section {
  margin-bottom: 24px;
}

.section-title {
  color: var(--especialidade-primary, #2e4b9d);
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 16px;
}

/* INPUTS MODERNOS */
.modern-select .v-input__control {
  border-radius: 12px !important;
  border: 2px solid #e0e0e0 !important;
  transition: all 0.3s ease !important;
}

.modern-select .v-input__control:hover {
  border-color: var(--especialidade-primary, #2e4b9d) !important;
  box-shadow: 0 0 0 3px rgba(46, 75, 157, 0.1) !important;
}

.modern-select .v-input__control:focus-within {
  border-color: var(--especialidade-primary, #2e4b9d) !important;
  box-shadow: 0 0 0 3px rgba(46, 75, 157, 0.2) !important;
}

/* AÇÕES */
.form-actions {
  padding: 24px 32px 32px 32px;
  border-top: 1px solid #f0f0f0;
  background: #fafafa;
}

.actions-container {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}

.action-btn {
  padding: 12px 24px !important;
  border-radius: 12px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  font-size: 14px !important;
  min-width: 120px !important;
  height: 44px !important;
  transition: all 0.3s ease !important;
}

.cancel-btn:hover {
  background: var(--especialidade-gradient, #2e4b9d) !important;
  color: #ffffff !important;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.save-btn {
  background: var(--especialidade-primary, #2e4b9d) !important;
  color: white !important;
  border: 2px solid var(--especialidade-primary, #2e4b9d) !important;
}

.save-btn:hover {
  background: var(--especialidade-secondary, #4a6bb5) !important;
  border-color: var(--especialidade-secondary, #4a6bb5) !important;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(46, 75, 157, 0.3);
}

.save-btn .v-icon {
  color: white !important;
}

.cancel-btn .v-icon {
  color: #ffffff !important;
}

/* RESPONSIVIDADE */
@media (max-width: 768px) {
  .impresso-modal-container {
    margin: 16px;
    max-width: calc(100vw - 32px);
  }

  .modal-header {
    padding: 20px 24px;
  }

  .header-title {
    font-size: 20px;
  }

  .form-content {
    padding: 24px;
  }

  .form-actions {
    padding: 20px 24px 24px 24px;
  }

  .actions-container {
    flex-direction: column;
  }

  .action-btn {
    width: 100% !important;
  }
}

/* ESPECIALIDADE CARDIOLOGIA */
.especialidade-cardiologia .modal-header {
  background: var(--especialidade-primary, #e91e63) !important;
}

.especialidade-cardiologia .save-btn {
  background: var(--especialidade-primary, #e91e63) !important;
  border-color: var(--especialidade-primary, #e91e63) !important;
}

.especialidade-cardiologia .save-btn:hover {
  background: var(--especialidade-secondary, #f06292) !important;
  border-color: var(--especialidade-secondary, #f06292) !important;
  box-shadow: 0 4px 12px rgba(233, 30, 99, 0.3);
}

.especialidade-cardiologia .modern-select .v-input__control:hover {
  border-color: var(--especialidade-primary, #e91e63) !important;
  box-shadow: 0 0 0 3px rgba(233, 30, 99, 0.1) !important;
}

.especialidade-cardiologia .modern-select .v-input__control:focus-within {
  border-color: var(--especialidade-primary, #e91e63) !important;
  box-shadow: 0 0 0 3px rgba(233, 30, 99, 0.2) !important;
}

.especialidade-cardiologia .section-title {
  color: var(--especialidade-primary, #e91e63);
}

/* ESPECIALIDADE PEDIATRIA */
.especialidade-pediatria .modal-header {
  background: var(--especialidade-primary, #15c4b4) !important;
}

.especialidade-pediatria .save-btn {
  background: var(--especialidade-primary, #15c4b4) !important;
  border-color: var(--especialidade-primary, #15c4b4) !important;
}

.especialidade-pediatria .save-btn:hover {
  background: var(--especialidade-secondary, #52e2cf) !important;
  border-color: var(--especialidade-secondary, #52e2cf) !important;
  box-shadow: 0 4px 12px rgba(21, 196, 180, 0.3);
}

.especialidade-pediatria .modern-select .v-input__control:hover {
  border-color: var(--especialidade-primary, #15c4b4) !important;
  box-shadow: 0 0 0 3px rgba(21, 196, 180, 0.1) !important;
}

.especialidade-pediatria .modern-select .v-input__control:focus-within {
  border-color: var(--especialidade-primary, #15c4b4) !important;
  box-shadow: 0 0 0 3px rgba(21, 196, 180, 0.2) !important;
}

.especialidade-pediatria .section-title {
  color: var(--especialidade-primary, #15c4b4);
}
</style>
